/**
 * Abmeldung von Rundmails (Link unten in jeder Rundmail: /abmelden?t=<Kürzel>, englisch /en/unsubscribe).
 * § 7 Abs. 3 UWG: Bestandskunden müssen Werbe-Mails jederzeit einfach widersprechen können.
 * Abgemeldet wird erst per Klick, nicht schon beim Öffnen: Mail-Scanner rufen Links oft vorab auf
 * und würden sonst Leute abmelden, die das nie wollten. Kauf-, Lizenz- und Login-Mails bleiben.
 */
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import FloatingHeader from '../components/layout/FloatingHeader';
import PageMeta from '../components/PageMeta';
import Footer from '../components/Footer';
import Lichtszene from '../components/licht/Lichtszene';
import { SEITEN_BLENDE } from '../components/animations/seitenBlende';
import '../components/startseite/startseite.css';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function Abmelden() {
  const location = useLocation();
  const en = location.pathname.startsWith('/en');
  const T = (de, e) => (en ? e : de);
  const token = new URLSearchParams(location.search).get('t') || '';
  // bereit | laeuft | erledigt | unbekannt | fehler
  const [stand, setStand] = useState(token ? 'bereit' : 'unbekannt');

  const abmelden = async () => {
    setStand('laeuft');
    try {
      const r = await fetch(`${API_URL}/api/rundmail/abmelden`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }),
      });
      if (!r.ok) throw new Error(String(r.status));
      const d = await r.json();
      setStand(d.gefunden ? 'erledigt' : 'unbekannt');
    } catch {
      setStand('fehler');
    }
  };

  const titel = {
    bereit: [T('Keine Rundmails mehr?', 'No more newsletters?'), T('Ein Klick genügt.', 'One click is enough.')],
    laeuft: [T('Keine Rundmails mehr?', 'No more newsletters?'), T('Einen Moment …', 'One moment …')],
    erledigt: [T('Du bist abgemeldet.', 'You’re unsubscribed.'), T('Ab jetzt keine Rundmails mehr.', 'No more newsletters from now on.')],
    unbekannt: [T('Dieser Link passt nicht.', 'This link doesn’t work.'), T('Schreib uns einfach.', 'Just write to us.')],
    fehler: [T('Das hat nicht geklappt.', 'That didn’t work.'), T('Bitte versuch es noch einmal.', 'Please try again.')],
  }[stand];

  return (
    <motion.div {...SEITEN_BLENDE}>
      <PageMeta title={T('Rundmails abbestellen | DAVIDMEDIA', 'Unsubscribe | DAVIDMEDIA')}
        description={T('Rundmails von David Media abbestellen.', 'Unsubscribe from David Media newsletters.')} noindex />
      <FloatingHeader />
      <div className="startseite">
        <Lichtszene />
        <section className="sek erste voll">
          <div className="innen" style={{ maxWidth: 720 }}>
            <span className="kicker">{T('Rundmails', 'Newsletter')}</span>
            <h1 className="als-h2">
              <span style={{ display: 'block' }}>{titel[0]}</span>
              <span className="grau" style={{ display: 'block' }}>{titel[1]}</span>
            </h1>
            <p className="lead">
              {stand === 'erledigt'
                ? T('Du bekommst von uns keine Rundmails mit Neuigkeiten mehr. Mails zu deinen Käufen, also Rechnung, Lizenz und Anmeldecodes, kommen weiterhin.',
                  'You won’t receive any more newsletters from us. Emails about your purchases, such as invoices, licenses and sign-in codes, will still arrive.')
                : stand === 'unbekannt'
                  ? <>{T('Wir konnten diesen Abmeldelink nicht zuordnen. Schreib uns an ', 'We couldn’t match this unsubscribe link. Write to ')}<a href="mailto:contact@davidmedia.de" style={{ color: 'var(--o)' }}>contact@davidmedia.de</a>{T(', dann tragen wir dich von Hand aus.', ' and we’ll remove you by hand.')}</>
                  : T('Dann bekommst du von uns keine Rundmails mit Neuigkeiten mehr. Mails zu deinen Käufen, also Rechnung, Lizenz und Anmeldecodes, kommen weiterhin.',
                    'Then you won’t receive any more newsletters from us. Emails about your purchases, such as invoices, licenses and sign-in codes, will still arrive.')}
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 28 }}>
              {(stand === 'bereit' || stand === 'laeuft' || stand === 'fehler') && (
                <button type="button" className="btn primaer" onClick={abmelden} disabled={stand === 'laeuft'}>
                  {stand === 'laeuft' ? T('Wird abgemeldet …', 'Unsubscribing …') : T('Jetzt abmelden', 'Unsubscribe now')}
                </button>
              )}
              <Link className="btn glas" to={en ? '/en' : '/'}>{T('Zur Startseite', 'Back home')}</Link>
            </div>
          </div>
        </section>
      </div>
      <div className="relative z-10"><Footer /></div>
    </motion.div>
  );
}
